import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.outsideClickListener = this.closeIfClickedOutside.bind(this)
    this.escapeListener = this.closeOnEscape.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.menuTarget.hidden) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.hidden = false
    document.addEventListener("click", this.outsideClickListener)
    document.addEventListener("keydown", this.escapeListener)
  }

  close() {
    this.menuTarget.hidden = true
    document.removeEventListener("click", this.outsideClickListener)
    document.removeEventListener("keydown", this.escapeListener)
  }

  closeIfClickedOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
} 